<template>
  <div class="subsystemCardList">
    <ul>
      <li v-for="(v, i) in listData" :key="i">
        <h5 :style="{ borderColor: listColor[i] }">
          {{ v.value }}
        </h5>
        <p>
          {{ v.name }} <span>{{ v.unit }}</span>
        </p>
      </li>
    </ul>
    <div class="controlBtn" v-if="listData.length && showDownload">
      <el-row>
        <el-button type="primary" @click="changeSwitch('ON')">全开</el-button>
      </el-row>
      <el-row>
        <el-button @click="changeSwitch('OFF')">全关</el-button>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    listData: {
      type: Array,
      default: () => [],
    },
    showDownload: {
      type: Boolean,
      default: true,
    },
    assetsTitle: {
      type: String,
      default: "区域",
    },
  },
  data() {
    return {
      listColor: [
        "#279fff",
        "#29c444",
        "#fecc2b",
        "#7472fc",
        "#279fff",
        "#29c444",
        "#fecc2b",
      ],
    };
  },
  watch: {},
  methods: {
    changeSwitch(type) {
      this.$emit("changeSwitch", {
        name: this.assetsTitle,
        isOpen: type,
        key: "RunSign",
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.subsystemCardList {
  width: 100%;
  height: 100%;
  @include setFlexBetween;
  ul {
    @include setFlexBetween;
    width: 86%;
    height: 100%;
    margin: 0 auto;
    li {
      width: 14%;
      height: 85%;
      @include setFlexColumn;
      justify-content: center;
      align-items: center;
      h5 {
        font-size: 20px;
        text-indent: 20px;
        border-left: 5px solid;
        margin-bottom: 10px;
      }
      p {
        text-indent: 30px;
        span {
          font-weight: normal;
          font-size: 12px;
          color: #999;
        }
      }
    }
  }
  .controlBtn {
    width: 12%;
    height: 100%;
    @include setFlexColumn;
    justify-content: space-between;
    .el-row {
      margin: 0 auto;
    }
  }
}
</style>
